import React, { Component } from 'react';
import { withRouter } from 'react-router';
// Styles
import './styles.scss';

// Constants
import { userConstants } from './userConstants';

// Components
import UpdateUserModalContainer from '../UpdateUserModal/UpdateUserModalContainer';
import NoUsersYet from './UsersList/EmptyUserList/NoUsersYet';
import GEUsersHeader from './GEUsersHeader/GEUsersHeader';
import NavigateBack from 'src/Components/NavigateBack/NavigateBack';
import UserListTable from './UsersList/UserListTable';
import SearchFieldGE from 'src/Components/SearchFieldGE/SearchFieldGE';
import HeaderSkeletonLoader from './GEUsersHeader/HeaderSkeletonLoader/HeaderSkeletonLoader';
import SuccessToast from 'src/Components/SuccessToast/SuccessToast';
import GETrainersLoader from 'src/Components/GETrainersLoader/GETrainersLoader';
import _ from 'lodash';
import { AnalyticsService } from 'src/Analytics/AnalyticsService';
import {
  updateAnalyticsForCustomerUsers,
  updateAnalyticsForAccountUsers
} from './analytics';
import { withTranslation } from 'react-i18next';
import { PulseLoader } from 'react-spinners';
import { GE_DOMAIN } from 'src/Config/constants';

let loginType = localStorage.getItem('loginType');
class GETrainers extends Component {
  state = {
    selectedUser: null,
    showModal: false,
    sortByAsc: true,
    activationKey: '',
    searchKey: '',
    isOnline: false,
    activePage: loginType === GE_DOMAIN ? 'customerUsers' : 'accountUsers',
    pagenumber: 1,
    totalPages: 0,
    customerUsersList: [],

    loading: false,
    updateStatus: false,
    event: null,
    timeStamp: '',
    isAvailableCheck: false,
  };

  getActivationKey = () => {
    let activationKey;
    if (this.props.location && this.props.location.state) {
      activationKey = this.props.location.state.activationKey;
    } else {
      let path = window.location.pathname;
      if (path.endsWith('/')) {
        path = path.slice(0, path.length - 2);
      }
      activationKey = path.split('/').pop();
    }
    return activationKey;
  };

  componentDidMount() {
    this.props.manageSidemenu(false);
    const activationKey = this.getActivationKey();
    this.setState({ activationKey, loading: true });
    this.props.getActivationKeyDetails(activationKey);
    this.props.getCustomerUsers({ activationKey });

    if (this.state.activePage === 'customerUsers') {
      updateAnalyticsForCustomerUsers(
        this.props.subscription?.subscriptionInfo?.sfdcUserId
      );
    } else {
      updateAnalyticsForAccountUsers(
        this.props.subscription?.subscriptionInfo?.sfdcUserId
      );
    }
  }

  loadMoreCustomerUsers = () => {
    let { searchKey, pagenumber } = this.state;

    let { limit = 10, totalPages } = this.props.customer?.customerUsers;
    const loadMore = true;
    if (
      pagenumber < totalPages &&
      (searchKey.length >= 2 || searchKey === '')
    ) {
      pagenumber = pagenumber + 1;
      const sort = this.state.sortByAsc ? 'ASC' : 'DESC';

      this.setState({ pagenumber },()=>{
              this.props.getCustomerUsers(
        {
          activationKey: this.getActivationKey(),
          searchKey,
          pagenumber,
          limit,
          sort,
        },
        loadMore
      );
      });
    }
  };

  getActivationKey = () => {
    let activationKey;
    if (this.props.location && this.props.location.state) {
      activationKey = this.props.location.state.activationKey;
    } else {
      activationKey = window.location.pathname.split('/').pop();
    }
    return activationKey;
  };

  handleChange = (value) => {
    const searchQuery = value;
    this.setState({ searchKey: searchQuery });
    if (searchQuery.length >= 2 || searchQuery === '') {
      this.setState({ loading: true });
      const sort = this.state.sortByAsc ? 'ASC' : 'DESC';
      let searchKey = value,
        activationKey = this.getActivationKey();
      
        this.props.getCustomerUsers({ activationKey, searchKey, sort });
     
    }
  };

  sortUsers = (sortBy) => {
    let { pageNumber } =
      this.props.customer && this.props.customer.customerUsers;
    const { searchKey, activationKey } = this.state;
    this.setState({
      loading: true,
      pagenumber: 1,
      sortByAsc: sortBy.sortByAsc,
      customerUsersList: [],
    
    });
    const sort = sortBy.sortByAsc ? 'ASC' : 'DESC';
    this.props.getCustomerUsers({ activationKey, searchKey, pageNumber, sort });
  };

  handleClearInput = (value) => {
    const searchKey = value;
    this.setState({searchKey:''})

    let activationKey = this.getActivationKey();
    this.setState({  loading: true });
    const sort = this.state.sortByAsc ? 'ASC' : 'DESC';
    
      this.props.getCustomerUsers({ activationKey, searchKey, sort });
   
  };

  addNewUser = () => {
    let  customerUsers;
   
    
      customerUsers = this.props.customer.customerUsers;
   
      
    let activationKey = this.getActivationKey();
    window.digitalData.link = {
      linkName: "Add Admin",
      linkType: "Add Admin",
    };

    AnalyticsService.updateDigitalData(digitalData);
    AnalyticsService.trackEvent('link_click');

    this.props.manageSidemenu(true);
    this.props.history.push(`/customer/${activationKey}/addAdmin`, {
      activationKey,
      facilityName: customerUsers.facilityName,
    });
  };

  renderFacilityDetails = () => {
    if (this.props.customer?.activationKeyDetails)
      return (
        <GEUsersHeader
          activePage={this.state.activePage}
          facilityDetails={this.props.customer.activationKeyDetails}
        />
      );
    return this.state.loading ? <HeaderSkeletonLoader /> : null;
  };

   componentDidUpdate(prevProps) {
    let { userDetails } = this.props.admin;
    let { selectedUser} = this.state;
    let isActive;
    if(selectedUser?.active === false) isActive = true;
    else isActive = false;

    let prevUserDetails = prevProps.admin.userDetails;
    if (prevUserDetails !== userDetails && userDetails && window.innerWidth > 599) {
      this.setState({
        showModal: true,
        isDisabled: isActive,
      });
    }
   
    let customerUsers = this.props.customer.customerUsers;
    let prevCustomerUsers = prevProps.customer.customerUsers;
    if (
      !_.isEmpty(customerUsers) &&
      prevCustomerUsers !== customerUsers
    ) {
      const usersList = customerUsers?.onyxCustomerSubscriptionDetail;
      this.setState({
        loading: false,
      });
      if (
        prevCustomerUsers?.onyxCustomerSubscriptionDetail !== customerUsers?.onyxCustomerSubscriptionDetail
      ) {
        this.setState({
          loading: false,
          customerUsersList: usersList,
          searchKey: this.state.searchKey,
        });
      }
      if (
        this.state.loading &&
        this.props.customer?.error?.status
      ) {
        this.setState({
          loading: false,
          updateStatus: false,
          customerUsersList: [],
        });
      }
    }
  }
  addNewTeamMember = () => {
    let { customerUsers } = this.props.customer;
    let activationKey = this.getActivationKey();
    window.digitalData.link = {
      linkName: "Add Team Member",
      linkType: 'Table Header'
    };

    AnalyticsService.trackEvent('link_click');
    this.props.manageSidemenu(true);
    this.props.history.push(`/people/${activationKey}/addMember`, {
      viewType: 'add',
      activationKey,
      facilityName: customerUsers.facilityName,
      userEmail: '',
    });
  };

  editUser = (user) => {
      let { customerUsers } = this.props.customer;
      let activationKey = this.getActivationKey();
      this.props.manageSidemenu(true);
      this.props.history.push(`/people/${activationKey}/addMember`, {
        viewType: 'edit',
        userEmail: user.email,
        activationKey,
        facilityName: customerUsers.facilityName,
      });
  };

  renderTableHeader = (count = 0) => {
    const { activePage, loading, searchKey } =
      this.state;
    let userCount = count;
    
    let addMember = activePage === 'customerUsers'? this.addNewUser: this.addNewTeamMember;

    const tableHead = document.querySelector('.table-head');
    if (tableHead !== null && activePage == 'accountUsers') {
      tableHead.style.gridTemplateColumns = '25% 25% 50%';
    }

    return (
      <div className="table-head">
        <span className="mobile-count-toggle">
          <span className="user-count-text">
            <span className="count-number">{userCount}</span>
            {userConstants[activePage].countText}
          </span>
          
        </span>

        <span className="add-admin-search-container">
          {!loading ? (
            <>
              <span
                className="add-admin-btn"
                onClick={addMember}
              >
                {' '}
                <span className="plus-add-admin"> + </span>
                {userConstants[activePage].addNewUserText}
              </span>
            </>
          ) : (
            <>
              <span className="add-admin-btn barred">
                {' '}
                <span className="plus-add-admin"> + </span>
                {userConstants[activePage].addNewUserText}
              </span>
            </>
          )}
        </span>
        <SearchFieldGE
          value={searchKey}
          placeholder={userConstants[activePage].searchPlaceholderText}
          className="search-people-input"
          onChange={this.handleChange}
          onClear={this.handleClearInput}
        />
      </div>
    );
  };

  getUserDetails = (user) => {
    let { activationKey } = this.state;
    this.setState({
      selectedUser: user,
    });
    this.props.getUserDetails(user.email, activationKey);
  };

  updateUserDetails = (user, isDisabled) => {
    const { activationKey, searchKey } = this.state;

    this.props.updateUser(activationKey, isDisabled, user.email, searchKey);
    this.cancelSelection();
  };

  dismissToast = () => {
    this.props.displayToast(false);
  };

  showNoUsersScreen = () => {
    const { customerUsers } = this.props.customer;
    const { activePage } = this.state;
  
      if (customerUsers && customerUsers.subStartDate) {
        return (
          <NoUsersYet
            page="subsNotStarted"
            subDate={customerUsers.subStartDate}
            activePage={activePage}
          />
        );
      } else {
        if (
          (customerUsers?.onyxCustomerSubscriptionDetail === null ||
            customerUsers?.onyxCustomerSubscriptionDetail?.length === 0) &&
          this.state.searchKey === ''
        ) {
          return (
            <NoUsersYet
              page="getStarted"
              addAdmin={this.addNewUser}
              activePage={activePage}
            />
          );
        }
      }
    
  };

  renderUserList = () => {
    const {
      searchKey,
      customerUsersList,
      loading,
      sortByAsc,
    } = this.state;
    const { customerUsers } = this.props.customer;
    let userList =  customerUsersList;
    let userLimit =  customerUsers && customerUsers.limit;
    const sortedItem = {
      sortField: 'name',
      sortByAsc: sortByAsc ? true : false,
    };
    let sortUser =  this.sortUsers;

    if (loading) 
      return (
        <div className="user-list-loader">
          <GETrainersLoader trainerScreen={true} />
        </div>
      )  
    else 
      return (
      <UserListTable
        usersList={userList}
        totalItems={this.calculateTotalItems()}
        pageNumber={this.calculatePagenumber()}
        totalPages={this.calculateTotalPages()}
        limit={userLimit}
        getUserDetails={this.getUserDetails}
        activePage={this.state.activePage}
        searchKey={searchKey}
        handleBtnClick={this.editUser}
        loadMore={this.loadMoreCustomerUsers}
        getMoreCustomerUsers={this.getMoreCustomerUsers}
        updateUser={this.updateUserDetails}
        sortUsers={sortUser}
        sortedItem={sortedItem}
      />
    )
  }

  cancelSelection = () => {
    this.setState({
      showModal: false,
    });
  };

  render() {
    const {
      activePage,
      showModal,
      isDisabled,
      activationKey,
      searchKey,
      loading,
    } = this.state;
    const { customerUsers } = this.props.customer;
    const { userDetails, showToast, toastMessage, isSingleAccount } =
      this.props.admin;
    let activeMenu = activePage === 'accountUsers' ? 'People' : 'Customers';
    let backButton;
    if (!isSingleAccount) backButton = (
        <NavigateBack />
      ) 
    else backButton = (
        <div className="empty-nav-bar"></div>
      )

    localStorage.setItem('activeItem', activeMenu);
    return (
      <div className="ge-trainers-wrapper">
 
        {this.props.generic.initialLoad ? <div className='init-loader'>
          <PulseLoader color={'#ffffff'} />
        </div> : <div className="ge-trainers-container">
          {showModal && (
            <UpdateUserModalContainer
              cancelSelection={this.cancelSelection}
              userDetails={userDetails}
              isDisabled={isDisabled}
              activationKey={activationKey}
              searchKey={searchKey}
            />
          )}
          {showToast && (
            <div className="success-toast">
              <SuccessToast
                message={toastMessage}
                dismissToast={this.dismissToast}
              />
            </div>
          )}
          {backButton}
          {this.renderFacilityDetails()}
          {(!loading && this.showNoUsersScreen()) || (
            <div className="user-list-parent__ge-trainers-wrapper">
              {this.renderTableHeader(
                customerUsers && customerUsers.totalItems
              )}
              {this.renderUserList()}
            </div>
          )}
        </div>}
      </div>
    );
  }

  calculateTotalItems = () =>{
   
    const { customerUsers } = this.props.customer;
   

   
      return customerUsers && customerUsers.totalItems;
  
  }

  calculatePagenumber = () => {
   
    const { customerUsers } = this.props.customer;
   

    
      return customerUsers && customerUsers.pageNumber;
   
  }

  calculateTotalPages = () =>{
    
    const { customerUsers } = this.props.customer;
    

    
      return customerUsers && customerUsers.totalPages;
   
  }
}

export default withTranslation()((withRouter(GETrainers)));
